import DropdownClickSelection from "./DropdownClickSelection";
import Modal from 'react-modal';
import { useState } from 'react';


function IconInfo({ data, clickSelection, setClickSelection, setChainSelection,
  connectionChains, chainSelection, chartClicked }) {

  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  const modalStyle = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  //   subtitle.style.color = '#726f6d';
  // }

  const dataRow = data.filter(d => +d.ID === clickSelection)[0];

  let geenSelectie = <p><em>{'Geen selectie gemaakt'}</em></p>;

  let info = '';
  let meerInfo = '';
  let toelichting = '';
  let img = '';
  let lange_omschrijving = '';
  let altText = '';
  if(clickSelection !== -1){
    geenSelectie = null;

    try {
     img = require("../../../assets/data/icons_witterand/" + dataRow['oorzaak effect impact'].replaceAll('/','') + ".png");
    }
    catch (e) {
      img = require("../../../assets/data/icons_witterand/Bermbranden.png");
    }

    if(dataRow['oorzaak effect impact'] !== ''){
      lange_omschrijving = (<>
        <h6><em>{dataRow['oorzaak effect impact']}</em></h6>
      </>)
      altText = dataRow['oorzaak effect impact'];
    }
    let aanpakken_oorzaak = '';
    if(dataRow['aanpakken oorzaak'] !== ''){
      aanpakken_oorzaak = (<>
        <h6>Aanpakken oorzaak</h6>
        <p>{dataRow['aanpakken oorzaak']}</p>
      </>)
    }
    let verminderen_gevoeligheid = '';
    if(dataRow['verminderen gevoeligheid'] !== ''){
      verminderen_gevoeligheid = (<>
        <h6>Verminderen gevoeligheid</h6>
        <p>{dataRow['verminderen gevoeligheid']}</p>
      </>)
    }
    let betrokken_partijen = '';
    if(dataRow['betrokken partijen'] !== ''){
      betrokken_partijen = (<>
        <h6>Betrokken partijen</h6>
        <p>{dataRow['betrokken partijen']}</p>
      </>)
    }
    let landschapstypen = '';
    const alleLandschapstypes = [
      'Droogmakerij',
      'Zeekleigebied',
      'Zeekleipolders',
      'Veenweidegebied',
      'Rivierengebied',
      'Ijsselmeerpolders',
      'Dekzandgebied',
      'Stuwwal',
      'Heuvelland',
      'Kust',
      'Veenkolonien',
      'Laagveen',
      'Hoogveen',
      'Rivierterrassen',
      'Strandwallenbinnenduinrand',
      'Voormalige hoogvenen'
    ];
    if(dataRow['landschapstypen (gidsmodel)'] !== ''){
      let temp_landschapstypen = (dataRow['landschapstypen (gidsmodel)'].includes('Nederland'))
        ? alleLandschapstypes.reduce((prev, curr) => prev + '; ' + curr)
        : dataRow['landschapstypen (gidsmodel)']
      landschapstypen = (<>
        <h6>Landschapstypen</h6>
        <p>{temp_landschapstypen}</p>
      </>)
    }

    if(dataRow['oorzaakeffectimpact_lang'] !== ''){
      toelichting = (<>
        <p>{dataRow['oorzaakeffectimpact_lang']}</p>
      </>)
    }


    info = (
      <div className='selectionInfo' padding='30px'>
        <div style={{'textAlign': 'center'}}>
          <img src={img} width='75'/>
          {lange_omschrijving}
        </div>
        {aanpakken_oorzaak}
        {verminderen_gevoeligheid}
        {betrokken_partijen}
        {landschapstypen}
      </div>
    )
    meerInfo = <button type='button' tabIndex='0' style={{ 'marginBottom':'5px' }} onClick={() => setIsOpen(true)}>Meer info</button>

  }

  /* <DropdownClickSelection data={data} clickSelection={clickSelection}
    setClickSelection={setClickSelection} setChainSelection={setChainSelection}
    connectionChains={connectionChains} chainSelection={chainSelection}
    chartClicked={chartClicked} /> */

  return (
    <div className="IconInfo">
      <h3>Geselecteerde impact/effect/oorzaak</h3>

      {geenSelectie}

      <img src={img} width='75' alt={altText}/>

      {lange_omschrijving}

      {toelichting}

      {meerInfo}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        style={modalStyle}
        contentLabel="Dit scherm laat meer gedetailleerde informatie zien over een geselecteerde oorzaak/effect/impact"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Toelichting</h2> */}
        <button onClick={() => setIsOpen(false)}
          style={{ position:'absolute', right:'4px', top:'4px' }}>
          Sluiten
        </button>
        <div style={{ width:'500px' }}>
          {info}
        </div>

      </Modal>

    </div>
  );
}

export default IconInfo;
